import React, { useEffect, useState } from 'react';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import ReCAPTCHA from 'react-google-recaptcha';
import Contact_Us_Seo from '../../SEO/Contact_Us_Seo';

function ContactUs() {
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState({ name: '', email: '', phoneno: '', msg: '' });
    const [errors, setErrors] = useState({});
    const [reCaptcha, setCaptchaToken] = useState('');

    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 500ms delay
    }, []);

    const validateForm = () => {
        const formErrors = {};
        if (!formData.name) {
            formErrors.name = 'Name is required';
        } else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
            formErrors.name = 'Name can only contain letters and spaces';
        }
        if (!formData.email) {
            formErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            formErrors.email = 'Email address is invalid';
        }
        if (!formData.phoneno) {
            formErrors.phoneno = 'Phone number is required';
        } else if (!/^\d{10,15}$/.test(formData.phoneno)) {
            formErrors.phoneno = 'Phone number is invalid';
        }
        if (!formData.msg) {
            formErrors.msg = 'Message is required';
        }
        if (!reCaptcha) {
            formErrors.captcha = 'Captcha is required';
        }
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                const response = await axios.post('https://finestpay.co.uk/prod/api/contactus/savecontactdetails', { ...formData, reCaptcha });
                const { responseCode, data } = response.data;

                if (responseCode === "00") {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Form submitted successfully!',
                        confirmButtonText: 'OK'
                    });
                    setFormData({ name: '', email: '', phoneno: '', msg: '' });
                    setCaptchaToken('');
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: data || 'There was an issue submitting the form. Please try again later.',
                        confirmButtonText: 'OK'
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'There was an issue submitting the form. Please try again later.',
                    confirmButtonText: 'OK'
                });
                console.error('Error submitting form:', error);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCaptchaChange = (token) => {
        setCaptchaToken(token);
    };

    return (
        <>
            {isLoading ? (
                <Preloader />
            ) : (
                <div>
                    <Contact_Us_Seo />
                    <div className="page-wrapper">
                        <Header />
                        <div className="content-wrapper">
                            <div className="breadcrumb-wrap bg-f">
                                <div className="overlay bg-vulcan op-9" />
                                <div className="container">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="breadcrumb-title">
                                                <h2>Contact Us</h2>
                                                <ul className="breadcrumb-menu list-style">
                                                    <li><NavLink to="/">Home</NavLink></li>
                                                    <li>Contact Us</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <section className="contact-us-wrap pt-100 pb-75">
                                <div className="container">
                                    <div className="section-title text-left style1 mb-40">
                                        <span>SEND MESSAGES</span>
                                        <h2>We Are Here To Help You</h2>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-4 col-md-6">
                                            <div className="contact-box">
                                                <div className="contact-icon"><i className="flaticon-pin" /></div>
                                                <div className="contact-info">
                                                    <h5>Address</h5>
                                                    <p>30, Ridley Road, Dalston, London, United Kingdom. E8 2NR</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6">
                                            <div className="contact-box">
                                                <div className="contact-icon"><i className="flaticon-email" /></div>
                                                <div className="contact-info">
                                                    <h5>Email</h5>
                                                    <NavLink to="mailto:info@finestpay.co.uk">info@finestpay.co.uk</NavLink>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6">
                                            <div className="contact-box">
                                                <div className="contact-icon"><i className="flaticon-call-1" /></div>
                                                <div className="contact-info">
                                                    <h5>Mobile Number</h5>
                                                    <NavLink to="tel:02036523240">020 3652 3240</NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xl-4">
                                            <div className="comp-map">
                                                <iframe
                                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2477.296150157007!2d0.02363667701694001!3d51.61778400263295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a0c060eed06d%3A0x3643643e1d564db3!2s17%20Woodside%20Rd%2C%20Woodford%2C%20Woodford%20Green!5e0!3m2!1sen!2suk!4v1730970240538!5m2!1sen!2suk"
                                                    allowFullScreen
                                                    aria-hidden="false"
                                                    tabIndex="0"
                                                    title="Location Map"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-8">
                                            <div className="contact-form">
                                                <form className="form-wrap contactForm" onSubmit={handleSubmit}>
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <input
                                                                    type="text"
                                                                    name="name"
                                                                    placeholder="Your Full Name*"
                                                                    value={formData.name}
                                                                    onChange={handleInputChange}
                                                                    aria-describedby="nameError"
                                                                />
                                                                {errors.name && <span id="nameError" className="error-text">{errors.name}</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="form-group">
                                                                <input
                                                                    type="email"
                                                                    name="email"
                                                                    placeholder="Email Address*"
                                                                    value={formData.email}
                                                                    onChange={handleInputChange}
                                                                    aria-describedby="emailError"
                                                                />
                                                                {errors.email && <span id="emailError" className="error-text">{errors.email}</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="form-group">
                                                                <input
                                                                    type="text"
                                                                    name="phoneno"
                                                                    placeholder="Phone Number*"
                                                                    value={formData.phoneno}
                                                                    onChange={handleInputChange}
                                                                    aria-describedby="phoneError"
                                                                />
                                                                {errors.phoneno && <span id="phoneError" className="error-text">{errors.phoneno}</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <textarea
                                                                    name="msg"
                                                                    placeholder="Your Messages.."
                                                                    value={formData.msg}
                                                                    onChange={handleInputChange}
                                                                    aria-describedby="messageError"
                                                                />
                                                                {errors.msg && <span id="messageError" className="error-text">{errors.msg}</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <ReCAPTCHA
                                                                    sitekey="6LeWRlIpAAAAACfghHUW7qOr4pbzT3kK2KCCBSvW"
                                                                    onChange={handleCaptchaChange}
                                                                />
                                                                {errors.captcha && <span className="error-text">{errors.captcha}</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <button type="submit" className="btn style1">Submit</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <Footer />
                    </div>
                </div>
            )}
        </>
    );
}

export default ContactUs;
